export var SET_POPUP_STATE = 'setPopupState';
export var SET_ELEMENT_STATE = 'setElementState';
export var SET_REGION_DATA = 'setRegionData';
export var SET_ERROR = 'setError';
export var CLEAR_ERROR = 'clearError';
export var simpleActionTypePrefix = '*_*';